import { BriefPortfolioModel } from "../../../market-place/providers/market-place/market-place.models";

export interface MarketPlaceCardObj {
    type: MarketPlaceCardsType;
    name: string;
    icon: string;
    tags: string;
    // Ai recommendation
    aiRecommended?: boolean;
}

export enum MarketPlaceCardsType {
    Subscribed = 'Subscribed',
    Originals = 'Originals',
    Verified = 'Verified',
    Details = 'Details',
    Created = 'Created',
    Bookmarked = 'Bookmarked'
}

export const StrategyTypeToCardType = [
    MarketPlaceCardsType.Originals, MarketPlaceCardsType.Verified
];

export const MarketPlaceCards: MarketPlaceCardObj[] = [
    {
        type: MarketPlaceCardsType.Originals,
        name: 'uTrade Originals',
        icon: '/assets/icons/original_icon.svg',
        tags: ""
    },
    {
        type: MarketPlaceCardsType.Bookmarked,
        name: 'Bookmarked Portfolios',
        icon: '/assets/icons/bookmarked.svg',
        tags: ""
    },
    {
        type: MarketPlaceCardsType.Created,
        name: 'Created Portfolios',
        icon: '/assets/icons/created.svg',
        tags: ""
    }
]

export const AiRecommendedMarketPlace: MarketPlaceCardObj = {
    type: MarketPlaceCardsType.Originals,
    name: "AI Recommended Originals",
    icon: '/assets/icons/ai_originals.svg',
    tags: "",
    aiRecommended: true
}

export interface RecommendOriginalsConfig {
    StrategyName: string;
    Multipliers: number;
    AllocatedCapital: number;
    Score: number;
    OnlyRecommended?: boolean;
}

export interface RecommendOriginalsData extends RecommendOriginalsConfig {
    portfolioId: string;
    deployed: boolean;
    totalMargin: number;
    minCash: number;
    multiplierRange: number[];
}


export interface MultiDeployOriginalsData {
    recommendOriginals: RecommendOriginalsConfig[];
    portfolios: BriefPortfolioModel[];
    deployedMargin: number;
    currentBalance: number;
}